import { fetchAuthSession } from "aws-amplify/auth";

const awsgateway = {
  API: {
    endpoints: [
      {
        name: "UserManagementApi",
        endpoint:
          "https://user-management.gateway.hubwise.co.uk/admin/v1/user-management",
        custom_header: async () => {
          return {
            Authorization: (await fetchAuthSession()).tokens?.idToken
          };
        },
      },
      {
        name: "ChangelogAPi",
        endpoint : "https://api-changelog.hubwise.co.uk/changelog?stage=prod",
        custom_header: async () => {
          return {
            Authorization: (await fetchAuthSession()).tokens?.idToken,
            Environment: "production",
          };
        },

      },
      {
        name: "PortalApi",
        endpoint: "https://adviser.gateway.hubwise.co.uk/admin/api",
        custom_header: async () => {
          return {
            Authorization: (await fetchAuthSession()).tokens?.idToken
          };
        }
      }
    ],
  },
};

export default awsgateway;
